module.exports = __webpack_public_path__ + "static/media/invite-list.6f2f889d.svg";